export type ChartingToolOptionValue = 'symSum' | 'sharpChart' | 'acp' | 'pnf' | 'gallery' | 'seasonality' | 'options' | 'perf' | 'candleGlance' | 'rrg' | 'symSearch';

export interface ChartingToolOption {
  title: string;
  value: ChartingToolOptionValue;
  iconClass: string;
  allowAsDefaultChartingToolOption: boolean;
  dividerBelow: boolean;
  url: string;
};

export const CHARTING_TOOL_OPTION_SYMBOL_SUMMARY: ChartingToolOption = {
  title: 'Symbol Summary',
  value: 'symSum',
  iconClass: 'far fa-fw fa-file-invoice-dollar',
  allowAsDefaultChartingToolOption: true,
  dividerBelow: false,
  url: '/freecharts/symbolsummary.html?sym='
};

export const CHARTING_TOOL_OPTION_SHARP_CHARTS: ChartingToolOption = {
  title: 'SharpChart',
  value: 'sharpChart',
  iconClass: 'custom-scc-icon icon-scc-pos-sq-sharp',
  allowAsDefaultChartingToolOption: true,
  dividerBelow: false,
  url: '/sc3/ui?s='
};

export const CHARTING_TOOL_OPTION_ACP: ChartingToolOption = {
  title: 'ACP',
  value: 'acp',
  iconClass: 'custom-scc-icon icon-scc-pos-sq-acp',
  allowAsDefaultChartingToolOption: true,
  dividerBelow: false,
  url: '/acp/?s='
};

export const CHARTING_TOOL_OPTION_POINT_AND_FIGURE: ChartingToolOption = {
  title: 'Point & Figure',
  value: 'pnf',
  iconClass: 'custom-scc-icon icon-scc-pos-sq-pnf',
  allowAsDefaultChartingToolOption: true,
  dividerBelow: false,
  url: '/freecharts/pnf.php?c='
};

export const CHARTING_TOOL_OPTION_GALLERY_VIEW: ChartingToolOption = {
  title: 'GalleryView',
  value: 'gallery',
  iconClass: 'custom-scc-icon icon-scc-pos-sq-gallery',
  allowAsDefaultChartingToolOption: true,
  dividerBelow: true,
  url: '/freecharts/gallery.html?'
};

export const CHARTING_TOOL_OPTION_SEASONALITY: ChartingToolOption = {
  title: 'Seasonality',
  value: 'seasonality',
  iconClass: 'custom-scc-icon icon-scc-pos-sq-season',
  allowAsDefaultChartingToolOption: false,
  dividerBelow: false,
  url: '/freecharts/seasonality.php?symbol='
};

export const CHARTING_TOOL_OPTION_OPTIONS: ChartingToolOption = {
  title: 'Options',
  value: 'options',
  iconClass: 'fas fa-fw fa-game-board-alt',
  allowAsDefaultChartingToolOption: false,
  dividerBelow: true,
  url: '/freecharts/options/?sym='
};

export const CHARTING_TOOL_OPTION_INTERACTIVE_PERF_CHART: ChartingToolOption = {
  title: 'Interactive PerfChart',
  value: 'perf',
  iconClass: 'custom-scc-icon icon-scc-pos-sq-perfchart',
  allowAsDefaultChartingToolOption: false,
  dividerBelow: false,
  url: '/freecharts/perf.html?'
};

export const CHARTING_TOOL_OPTION_CANDLE_GLANCE: ChartingToolOption = {
  title: 'CandleGlance',
  value: 'candleGlance',
  iconClass: 'custom-scc-icon icon-scc-pos-sq-candle',
  allowAsDefaultChartingToolOption: false,
  dividerBelow: false,
  url: '/freecharts/candleglance.html?'
};

export const CHARTING_TOOL_OPTION_RRG: ChartingToolOption = {
  title: 'RRG',
  value: 'rrg',
  iconClass: 'custom-scc-icon icon-scc-pos-sq-rrg',
  allowAsDefaultChartingToolOption: false,
  dividerBelow: true,
  url: '/freecharts/rrg/?b=$SPX&p=w&y=1&t=10&f=tail,d&s='
};

export const CHARTING_TOOL_OPTION_SYMBOL_LOOKUP: ChartingToolOption = {
  title: 'Symbol Lookup',
  value: 'symSearch',
  iconClass: 'fas fa-fw fa-search-plus',
  allowAsDefaultChartingToolOption: false,
  dividerBelow: false,
  url: '/search/?section=symbol&q='
};

export const DEFAULT_CHARTING_TOOL_OPTION: ChartingToolOption = CHARTING_TOOL_OPTION_SHARP_CHARTS;

export const CHARTING_TOOL_OPTIONS_ARRAY: ChartingToolOption[] = [
  CHARTING_TOOL_OPTION_SYMBOL_SUMMARY,
  CHARTING_TOOL_OPTION_SHARP_CHARTS,
  CHARTING_TOOL_OPTION_ACP,
  CHARTING_TOOL_OPTION_POINT_AND_FIGURE,
  CHARTING_TOOL_OPTION_GALLERY_VIEW,
  CHARTING_TOOL_OPTION_SEASONALITY,
  CHARTING_TOOL_OPTION_OPTIONS,
  CHARTING_TOOL_OPTION_INTERACTIVE_PERF_CHART,
  CHARTING_TOOL_OPTION_CANDLE_GLANCE,
  CHARTING_TOOL_OPTION_RRG,
  CHARTING_TOOL_OPTION_SYMBOL_LOOKUP
];

export function getChartingToolObjFromChartingToolValue(chartingToolValue: ChartingToolOptionValue): ChartingToolOption {
  return CHARTING_TOOL_OPTIONS_ARRAY.find(ct => ct.value === chartingToolValue) ?? DEFAULT_CHARTING_TOOL_OPTION;
}
